import React, { useContext, useEffect, useState } from "react";
import TemplateBackend from "../../components/TemplateBackend";
import { LoginContext } from "../../contexts/login_context";
import { hitsPerDay } from "../../services/hitsPerDay";
import { companyActiveUsers } from "../../services/companyActiveUsers";
import Loading from "../../components/Loading";
import "./style.css";
import { showError } from "../../services/toast";
import { newUsersPerDay } from "../../services/newUsersPerDay";
import AsyncSelect from "react-select/async";
import { getUserGS1Companies, getUserGS1CompaniesDash } from "../../services/getUserGS1Companies";
import { useSelector } from "../../native-state.dev";
import Chart from "./chart";
import DatePicker from "../../components/date-picker/DatePicker";
import { toast } from "react-toastify";
import { acessosPeriodoVBG } from "../../services/acessosPeriodoVBG";
import { totalUserCompany } from "../../services/totalUserCompany";
import { consumptionPeriod } from "../../services/consumptionPeriod";
import { acessosPeriodoVBGEmpresaAll } from "../../services/acessPeriodoVGBEmpresaAll";
import { consumptionPeriodEmpresaAll } from "../../services/consumptionPeriodAll";
import BarChart from "./BarChat";
import { consumoPeriodoBuscaEmpresa } from "../../services/consumoPeriodoBuscaEmpresa";
import { consumptionPeriodInternacional } from "../../services/ccconsumptionPeriodInternational";
import { consumptionPeriodNational } from "../../services/ConsumptionPeriodNational";

const NewDashboard = () => {
  const [modalObje, setState] = useSelector(
    (s: { searchDone: any }) => s.searchDone
  );

  const { jwt, perfil, empresaId } = useContext(LoginContext);
  const [AllUserCompany, SetAllUserCompany] = useState<number>(0);
  const [activeusers, setActiveusers] = useState<number>(-1);
  const [hitsperday, setHitsperday] = useState<number>(-1);
  const [newusersperday, setNewusersperday] = useState<number>(-1);
  const [consumptionday, setConsumptionday] = useState<number>(-1);
  const [associated, setAssociated] = useState<number>(-1);
  const [companyhitsday, setCompanyhitsday] = useState<number>(0);
  const [consumptioncompanyday, setConsumptioncompanyday] = useState({
    used: 0,
    limit: 0,
  });
  const [consumptionNacionalGtin, setConsumptionNacionalGtin] =
    useState<number>(0);
  const [consumptionInternationalGtin, setConsumptionInternationalGtin] =
    useState<number>(0);
  const [consumptionNacionalGln, setConsumptionNacionalGln] =
    useState<number>(0);
  const [consumptionBuscaEmpresa, setConsumptionBuscaEmpresa] =
    useState<number>(0);
  const [consumptionInternationalGln, setConsumptionInternationalGln] =
    useState<number>(0);
  const [companyusers, setCompanyusers] = useState<number>(-1);
  const [showloading, setShowLoading] = useState(false);
  const [filterDate, setFilterDate] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [filterDateCompany, setFilterDateCompany] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [filterCompany, setFilterCompany] = useState("0");
  const [idCompanySelect, setIdCompanySelect] = useState("");
  const [date, setDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [dateReport, setDateReport] = useState<Date | null>(new Date());
  const [endDateReport, setEndDateReport] = useState<Date | null>(new Date());
  const [startHistoryConsult, seStartHistoryConsult] = useState<Date | null>(
    new Date()
  );
  const [endHistoryConsult, setEndHistoryConsult] = useState<Date | null>(
    new Date()
  );
  const [acessVBGDay, setAcessVBGDay] = useState<number>(-1);
  const [consumptionPeriodo, setConsumptionPeriodo] = useState<number>(0);
  const dateStartStr = date ? date.toISOString().split("T")[0] : "";
  const dateEndStr = endDate ? endDate.toISOString().split("T")[0] : "";
  const [ConsumptionPeriodoAll, setConsumptionPeriodoAll] = useState<number>(0);

  const dateStartHistoryConsult = startHistoryConsult
    ? startHistoryConsult.toISOString().split("T")[0]
    : "";
  const dateEndHistoryConsult = endHistoryConsult
    ? endHistoryConsult.toISOString().split("T")[0]
    : "";

  const dateStartStrReport = dateReport
    ? dateReport.toISOString().split("T")[0]
    : "";
  const dateEndStrReport = endDateReport
    ? endDateReport.toISOString().split("T")[0]
    : "";

  const [allCompanies, setAllCompanies] = useState<any[]>([]);

  function loadData(dataPesquisa: string) {
    setConsumptionday(-1);
    setHitsperday(-1);
    setNewusersperday(-1);

    hitsPerDay(jwt, dataPesquisa).then((hits: any) => {
      if (hits.success) setHitsperday(hits.result);
      else showError(hits.message);
    });

    newUsersPerDay(jwt, dataPesquisa).then((hits: any) => {
      if (hits.success) setNewusersperday(hits.result);
      else showError(hits.message);
    });
  }

  useEffect(() => {
    if (perfil.indexOf("GS1") >= 0) {
      fetchCompanies();
      setAssociated(-1);
      setActiveusers(-1);
    }

    if (perfil.indexOf("GS1") >= 0 && filterDate) {
      loadData(filterDate);
    }

    if (perfil.indexOf("GS1") >= 0) {
      handleDateChangeAcessAll();
    } else {
      handleDateChangeAcessGS1();
    }

    if (perfil.indexOf("GS1") >= 0) {
      consumptionPeriodAll();
    }

    DataConsumptionPeriodNacionalGtin();
    consumptionPeriodDate();
    DataConsumptionPeriodInternationalGtin();
    DataConsumptionPeriodInternationalGln();
    DataConsumptionPeriodNacionalGln();
    DataconsumoPeriodoBuscaEmpresa();
    AccessDash();
    TotalUserCompany();
    usersActive();
    setIdCompanySelect(
      perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId
    );
    setState({ searchDone: false });
  }, [
    perfil,
    empresaId,
    filterCompany,
    jwt,
    filterDate,
    filterDateCompany,
    idCompanySelect,
    dateStartStr,
    dateEndStr,
    dateStartStrReport,
    dateEndStrReport,
    dateStartHistoryConsult,
    dateEndHistoryConsult,
  ]);

  const fetchCompanies = async () => {
    const response = await getUserGS1CompaniesDash(jwt);

    if (response.success) {
      if (Array.isArray(response.result)) {
        const companies = response.result.map((empresa: any) => ({
          value: empresa.id,
          label: empresa.nome,
        }));
        setAllCompanies(companies);
      } else {
        showError("Dados de empresas inválidos recebidos do servidor.");
        setAllCompanies([]);
      }
    } else {
      showError(response.message);
    }
  };

  const filterCompanies = (inputValue: string) => {
    return allCompanies.filter((company) =>
      company.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const loadOptions = (inputValue: string, callback: any) => {
    const filtered = filterCompanies(inputValue);
    callback(filtered);
  };

  const isWithinThreeMonths = (start: Date, end: Date) => {
    const maxEndDate = new Date(start);
    maxEndDate.setMonth(maxEndDate.getMonth() + 3);
    return end < maxEndDate;
  };

  const handleEndDateReportChange = (newEndDate: Date | null) => {
    if (newEndDate && dateReport) {
      if (!isWithinThreeMonths(dateReport, newEndDate)) {
        toast.error(
          "Selecione uma data final que esteja no máximo 3 meses após a data inicial."
        );
        setEndDateReport(null);
        return;
      }
    }
    setEndDateReport(newEndDate);
  };

  const handleStartDateReportChange = (newDate: Date | null) => {
    if (newDate && endDateReport) {
      if (!isWithinThreeMonths(newDate, endDateReport)) {
        toast.error(
          "Selecione uma data final que esteja no máximo 3 meses após a data inicial."
        );
        setDateReport(null);
        return;
      }
    }
    setDateReport(newDate);
  };

  const handleEndDateChange = (newEndDate: Date | null) => {
    if (newEndDate && date) {
      if (!isWithinThreeMonths(date, newEndDate)) {
        toast.error(
          "Selecione uma data final que esteja no máximo 3 meses após a data inicial."
        );
        setEndDate(null);
        return;
      }
    }
    setEndDate(newEndDate);
  };

  const handleStartDateChange = (newDate: Date | null) => {
    if (newDate && endDate) {
      if (!isWithinThreeMonths(newDate, endDate)) {
        toast.error(
          "Selecione uma data final que esteja no máximo 3 meses após a data inicial."
        );
        setDate(null);
        return;
      }
    }
    setDate(newDate);
  };
  function handleDateChangeAcessGS1() {
    if (!dateStartStr || !dateEndStr) return;

    const AcessosVGB = async () => {
      try {
        if (empresaId === "") return;

        const response = await acessosPeriodoVBG(
          jwt,
          empresaId,
          dateStartStr,
          dateEndStr
        );
        const data = response;
        setAcessVBGDay(data.result.acessosPeriodo);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };

    AcessosVGB();
  }

  function AccessDash() {
    if (!dateStartStr || !dateEndStr) return;

    const AcessosVGBDash = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await acessosPeriodoVBG(
          jwt,
          idToUse,
          dateStartStrReport,
          dateEndStrReport
        );
        const data = response;
        setCompanyhitsday(data.result.acessosPeriodo);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };

    AcessosVGBDash();
  }

  function handleDateChangeAcessAll() {
    if (!dateStartStr || !dateEndStr) return;

    const AcessosVGBAll = async () => {
      try {
        const response = await acessosPeriodoVBGEmpresaAll(
          jwt,
          dateStartStr,
          dateEndStr
        );
        const data = response;
        setAcessVBGDay(data.result.acessosPeriodo);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };

    AcessosVGBAll();
  }

  function TotalUserCompany() {
    const fetchTotalusersCompany = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await totalUserCompany(jwt, idToUse);
        const data = response;
        SetAllUserCompany(data.result.usuarioAtivoEmpresa);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };

    fetchTotalusersCompany();
  }

  function usersActive() {
    const fetchActiversUsers = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await companyActiveUsers(jwt, idToUse);
        const data = response;
        setCompanyusers(data.result.usuariosAtivos);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };

    fetchActiversUsers();
  }

  function consumptionPeriodDate() {
    if (!dateStartStrReport || !dateEndStrReport) return;

    const fetchConsumptionPeriod = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await consumptionPeriod(
          jwt,
          idToUse,
          dateStartStrReport,
          dateEndStrReport
        );
        const data = response;
        setConsumptionPeriodo(data.result.consumoPeriodo);
        setConsumptioncompanyday({
          used: data.result.consumoPeriodo,
          limit: data.result.limiteEmpresa,
        });
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };
    fetchConsumptionPeriod();
  }

  function consumptionPeriodAll() {
    if (!dateStartStr || !dateEndStr) return;

    const fetchConsumptionPeriodAll = async () => {
      try {
        const response = await consumptionPeriodEmpresaAll(
          jwt,
          dateStartStr,
          dateEndStr
        );
        const data = response;
        setConsumptionPeriodoAll(data.result.consumoPeriodo);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };
    fetchConsumptionPeriodAll();
  }

  function DataConsumptionPeriodNacionalGtin() {
    if (!dateStartStrReport || !dateEndStrReport) return;

    const fetchConsumptionNationalGtin = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await consumptionPeriodNational(
          jwt,
          idToUse,
          dateStartStrReport,
          dateEndStrReport,
          "gtin"
        );
        const data = response;
        setConsumptionNacionalGtin(data.result.total);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };
    fetchConsumptionNationalGtin();
  }

  function DataConsumptionPeriodNacionalGln() {
    if (!dateStartStrReport || !dateEndStrReport) return;

    const fetchConsumptionNationalGln = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await consumptionPeriodNational(
          jwt,
          idToUse,
          dateStartStrReport,
          dateEndStrReport,
          "gln"
        );
        const data = response;
        setConsumptionNacionalGln(data.result.total);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };
    fetchConsumptionNationalGln();
  }

  function DataconsumoPeriodoBuscaEmpresa() {
    if (!dateStartStrReport || !dateEndStrReport) return;

    const fetchConsumoPeriodoBuscaEmpresa = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await consumoPeriodoBuscaEmpresa(
          jwt,
          idToUse,
          dateStartStrReport,
          dateEndStrReport
        );
        const data = response;
        setConsumptionBuscaEmpresa(data.result.total);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };
    fetchConsumoPeriodoBuscaEmpresa();
  }

  function DataConsumptionPeriodInternationalGln() {
    if (!dateStartStrReport || !dateEndStrReport) return;

    const fetchConsumptionPeriodInternationalGln = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await consumptionPeriodInternacional(
          jwt,
          idToUse,
          dateStartStrReport,
          dateEndStrReport,
          "gln"
        );
        const data = response;
        setConsumptionInternationalGln(data.result.total);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };
    fetchConsumptionPeriodInternationalGln();
  }

  function DataConsumptionPeriodInternationalGtin() {
    if (!dateStartStrReport || !dateEndStrReport) return;

    const fetchConsumptionPeriodInternationalGtin = async () => {
      try {
        const idToUse =
          perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId;

        if (idToUse === "") return;

        const response = await consumptionPeriodInternacional(
          jwt,
          idToUse,
          dateStartStrReport,
          dateEndStrReport,
          "gtin"
        );
        const data = response;
        setConsumptionInternationalGtin(data.result.total);
      } catch (error) {
        console.log("Erro ao buscar os dados:", error);
      }
    };
    fetchConsumptionPeriodInternationalGtin();
  }

  const handleStartDateHistoryChange = (newEndDate: Date | null) => {
    if (newEndDate && startHistoryConsult) {
      if (!isWithinThreeMonths(startHistoryConsult, newEndDate)) {
        toast.error(
          "Selecione uma data final que esteja no máximo 3 meses após a data inicial."
        );
        seStartHistoryConsult(null);

        return;
      }
    }
    seStartHistoryConsult(newEndDate);
  };

  const handleEndDateHistoryChange = (newEndDate: Date | null) => {
    if (newEndDate && startHistoryConsult) {
      if (!isWithinThreeMonths(startHistoryConsult, newEndDate)) {
        toast.error(
          "Selecione uma data final que esteja no máximo 3 meses após a data inicial."
        );
        setEndHistoryConsult(null);

        return;
      }
    }
    setEndHistoryConsult(newEndDate);
  };
  const calculateDaysDiff = (start: Date | null, end: Date | null): number => {
    if (!start || !end) return 0;
    const startDate = new Date(start.toDateString());
    const endDate = new Date(end.toDateString());
    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 para incluir ambos os dias
  };
  const getCompaniesByName = (name : string, callback: (options : []) => void) => {
    if (name == null || name.length < 3)
        callback([]);


    getUserGS1Companies(jwt, name).then(
        (responseUserGS1Companies: any) => {
            let companies: any = [];

            if (responseUserGS1Companies.success) {
                responseUserGS1Companies.result.forEach((element: any, index: any) => {
                    companies.push({ value: element.id, label: element.nome });
                })

                callback(companies);

            }
            else {
                showError(responseUserGS1Companies.message);
            }
        }
    )
}
  return (
    <>
      <TemplateBackend>
        {perfil.indexOf("GS1") >= 0 && (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "25px",
              }}
            >
              <h3
                style={{
                  marginTop: 0,
                  paddingLeft: "15px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Relatório Geral de Uso
              </h3>

              <div className=" col-lg-4 col-sm-12 mb-4 mb-sm-2 float-md-right">
                <div
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "4px",
                          fontSize: "14px",
                          color: "#333",
                        }}
                      >
                        Data Inicial
                      </label>
                      <DatePicker
                        value={date}
                        onChange={handleStartDateChange}
                        clearable
                        inputtable
                        inputFormat="DD/MM/YYYY"
                        locale="pt-BR"
                        size="sm"
                      />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "4px",
                          fontSize: "14px",
                          color: "#333",
                        }}
                      >
                        Data Final
                      </label>
                      <div
                        style={{ display: "inline-block", marginLeft: "5px" }}
                      >
                        <DatePicker
                          value={endDate}
                          onChange={handleEndDateChange}
                          clearable
                          inputtable
                          inputFormat="DD/MM/YYYY"
                          locale="pt-BR"
                          size="sm"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex">
              <div className="customDisplayFlex dashGroup">
                <div className="col-12 col-md-5 col-lg-4 mb-4">
                  <div className="ms-webpart-zone ms-fullWidth ">
                    <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                      <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                        <div className="ms-WPBody noindex ">
                          <div className="ms-rte-embedcode ms-rte-embedwp">
                            <div className="statistic-tile rounded-lg customMaxWidth ">
                              <div className="number-statistic gs1-color-sky ">
                                {acessVBGDay < 0 && (
                                  <>
                                    <Loading />
                                  </>
                                )}
                                {acessVBGDay >= 0 && acessVBGDay}
                              </div>
                              <div className="description-statistic ">
                                Acessos no periodo
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-5 col-lg-4 mb-4">
                  <div className="ms-webpart-zone ms-fullWidth">
                    <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                      <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                        <div className="ms-WPBody noindex ">
                          <div className="ms-rte-embedcode ms-rte-embedwp">
                            <div className="statistic-tile rounded-lg customMaxWidth bgColor">
                              <div className="number-statistic gs1-color-sky bgColor">
                                {ConsumptionPeriodoAll < 0 && (
                                  <>
                                    <Loading />
                                  </>
                                )}
                                {ConsumptionPeriodoAll >= 0 &&
                                  ConsumptionPeriodoAll}
                              </div>
                              <div className="description-statistic bgColor">
                                Total de consultas
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {false && (
              <div
                className="row mb-4 pb-5"
                style={{ borderBottom: "solid 1px #ebebeb" }}
              >
                <div className="col-12">
                  <h4>Dados de cadastros</h4>
                </div>

                <div className="col-12 col-md-5 mb-4">
                  <div className="ms-webpart-zone ms-fullWidth">
                    <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                      <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                        <div className="ms-WPBody noindex ">
                          <div className="ms-rte-embedcode ms-rte-embedwp">
                            <div className="statistic-tile bgColor">
                              <div className="number-statistic gs1-color-sky bgColor">
                                {associated < 0 && (
                                  <>
                                    <Loading />
                                  </>
                                )}
                                {associated >= 0 && associated}
                              </div>
                              <div className="description-statistic bgColor">
                                Empresas associadas
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-5 mb-4">
                  <div className="ms-webpart-zone ms-fullWidth">
                    <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                      <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                        <div className="ms-WPBody noindex ">
                          <div className="ms-rte-embedcode ms-rte-embedwp">
                            <div className="statistic-tile ">
                              <div className="number-statistic gs1-color-sky ">
                                {companyusers < 0 && (
                                  <>
                                    <Loading />
                                  </>
                                )}
                                {companyusers >= 0 && companyusers}
                              </div>
                              <div className="description-statistic ">
                                {" "}
                                Usuários ativos
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        <div className="">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "25px",
            }}
          >
            <h3 style={{ marginTop: 0, paddingLeft: "15px" }}>
              Relatório de Uso por Empresa
            </h3>

            <div className="col-12 col-md-4 col-lg-4 col-sm-12 mb-4 mb-sm-2 float-md-right">
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "4px",
                        fontSize: "14px",
                        color: "#333",
                      }}
                    >
                      Data Inicial
                    </label>
                    <DatePicker
                      value={dateReport}
                      onChange={handleStartDateReportChange}
                      clearable
                      inputtable
                      inputFormat="DD/MM/YYYY"
                      locale="pt-BR"
                      size="sm"
                    />
                  </div>

                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "4px",
                        fontSize: "14px",
                        color: "#333",
                      }}
                    >
                      Data Final
                    </label>
                    <div style={{ display: "inline-block", marginLeft: "5px" }}>
                      <DatePicker
                        value={endDateReport}
                        onChange={handleEndDateReportChange}
                        clearable
                        inputtable
                        inputFormat="DD/MM/YYYY"
                        locale="pt-BR"
                        size="sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {perfil.indexOf("GS1") >= 0 && (
            <div className="col-12 mb-5 mt-4 pt-3" style={{ width: "100%" }}>
                    <AsyncSelect
                        classNamePrefix="asyncSelect"
                        cacheOptions
                        defaultValue={{label:"Digite o código da empresa para buscar"}}
                        loadingMessage={() => "Carregando..."}
                        noOptionsMessage={(item) => item.inputValue.length > 3 ? "Nenhum item encontrado." : "Digite o código da empresa para buscar..."}
                        loadOptions={getCompaniesByName}
                        onChange={(item : any) => {
                            if(item) {
                              setIdCompanySelect(item.value);
                            }
                        }
                        }/>
            </div>
          )}
          <>
            {idCompanySelect !== "" && (
              <div className="">
                <div className="dashGroup">
                  <div className="grid-container ">
                    <div className="col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile rounded-lg customMaxWidth ">
                                  <div className="number-statistic gs1-color-sky ">
                                    {companyhitsday < 0 && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {companyhitsday >= 0 && `${companyhitsday}`}
                                  </div>
                                  <div className="description-statistic ">
                                    Acessos
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile rounded-lg customMaxWidth ">
                                  <div className="number-statistic gs1-color-sky ">
                                    {AllUserCompany < 0 && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {AllUserCompany >= 0 && AllUserCompany}
                                  </div>
                                  <div className="description-statistic ">
                                    Total de usuários
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile  rounded-lg customMaxWidth bgColor">
                                  <div className="number-statistic gs1-color-sky bgColor">
                                    {companyusers < 0 && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {companyusers >= 0 && companyusers}
                                  </div>
                                  <div className="description-statistic bgColor">
                                    Total de usuários ativos
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="grid-container ">
                      {perfil.indexOf("GS1") >= 0 && (
                        <>
                          <div className="">
                            <Chart
                              used={consumptioncompanyday.used}
                              limit={
                                consumptioncompanyday.limit *
                                calculateDaysDiff(dateReport, endDateReport)
                              }
                            />
                          </div>
                          <div className="col-2 col-md-2 mb-2">
                        <div className="ms-webpart-zone ms-fullWidth">
                          <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                            <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                              <div className="ms-WPBody noindex ">
                                <div className="ms-rte-embedcode ms-rte-embedwp">
                                  <div className="statistic-tile  rounded-lg customMaxWidth ">
                                    <div className="number-statistic gs1-color-sky ">
                                      {showloading && (
                                        <>
                                          <Loading />
                                        </>
                                      )}
                                      {!showloading && `${consumptioncompanyday.limit }`}
                                    </div>
                                    <div className="description-statistic ">
                                      Quantidade disponível por dia
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        </>
                      )}

                      <div className="col-2 col-md-2 mb-2">
                        <div className="ms-webpart-zone ms-fullWidth">
                          <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                            <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                              <div className="ms-WPBody noindex ">
                                <div className="ms-rte-embedcode ms-rte-embedwp">
                                  <div className="statistic-tile  rounded-lg customMaxWidth bgColor">
                                    <div className="number-statistic gs1-color-sky bgColor">
                                      {showloading && (
                                        <>
                                          <Loading />
                                        </>
                                      )}
                                      {!showloading && `${consumptionPeriodo}`}
                                    </div>
                                    <div className="description-statistic bgColor">
                                      Total de consultas pela empresa
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "15px",
                        marginLeft: "15px",
                      }}
                    >
                      {perfil.indexOf("GS1") >= 0 && (
                        <>
                          {" "}
                          <span
                            style={{
                              marginTop: "-20px",
                              fontSize: "15px",
                              marginLeft: "30px",
                              display: "flex",
                              position: "relative",
                              zIndex: 9,
                              alignItems: "center", // Alinha o quadrado e o texto na horizontal
                            }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: "10px", // Tamanho do quadrado
                                height: "10px", // Tamanho do quadrado
                                backgroundColor: "#00b6de", // Cor do quadrado
                                marginRight: "5px", // Espaçamento entre o quadrado e o texto
                              }}
                            ></span>
                            % de consultas realizadas
                          </span>
                        </>
                      )}
                      <span>
                        As informações disponíveis refletem as condições do
                        contrato atual.
                      </span>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="col-12 col-md-12 mb-2 mt-4">
                    CONSULTAS POR GTIN
                  </div>
                  <div className="grid-container dashGroup">
                    <div className="col-12 col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile  rounded-lg customMaxWidth ">
                                  <div className="number-statistic gs1-color-sky ">
                                    {showloading && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {!showloading &&
                                      `${consumptionNacionalGtin}`}
                                  </div>
                                  <div className="description-statistic ">
                                    Consultas nacionais
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile  rounded-lg customMaxWidth ">
                                  <div className="number-statistic gs1-color-sky ">
                                    {showloading && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {!showloading &&
                                      `${consumptionInternationalGtin} `}
                                  </div>
                                  <div className="description-statistic ">
                                    Consultas internacionais
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile  rounded-lg customMaxWidth bgColor">
                                  <div className="number-statistic gs1-color-sky bgColor">
                                    {showloading && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {!showloading &&
                                      `${
                                        consumptionInternationalGtin +
                                        consumptionNacionalGtin
                                      }`}
                                  </div>
                                  <div className="description-statistic bgColor">
                                    Consultas realizadas
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="col-12 col-md-12 mb-2 mt-4">
                    CONSULTA POR OUTRAS CHAVES (GLN + OUTRAS CHAVES){" "}
                  </div>
                  <div className="grid-container dashGroup">
                    <div className="col-12 col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile  rounded-lg customMaxWidth ">
                                  <div className="number-statistic gs1-color-sky ">
                                    {showloading && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {!showloading &&
                                      `${consumptionNacionalGln}`}
                                  </div>
                                  <div className="description-statistic ">
                                    Consultas nacionais
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile  rounded-lg customMaxWidth ">
                                  <div className="number-statistic gs1-color-sky ">
                                    {showloading && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {!showloading &&
                                      `${consumptionInternationalGln} `}
                                  </div>
                                  <div className="description-statistic ">
                                    Consultas internacionais
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-5 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile  rounded-lg customMaxWidth bgColor">
                                  <div className="number-statistic gs1-color-sky bgColor">
                                    {showloading && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {!showloading &&
                                      `${
                                        consumptionInternationalGln +
                                        consumptionNacionalGln
                                      }`}
                                  </div>
                                  <div className="description-statistic bgColor">
                                    Consultas realizadas
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="col-12 col-md-12 mb-2 mt-4">
                    CONSULTAS PELO NOME DA EMPRESA
                  </div>

                  <div className="grid-container dashGroup">
                    <div className="col-12 mb-4">
                      <div className="ms-webpart-zone ms-fullWidth">
                        <div className="s4-wpcell-plain ms-webpartzone-cell ms-webpart-cell-vertical ms-fullWidth ">
                          <div className="ms-webpart-chrome ms-webpart-chrome-vertical ms-webpart-chrome-fullWidth ">
                            <div className="ms-WPBody noindex ">
                              <div className="ms-rte-embedcode ms-rte-embedwp">
                                <div className="statistic-tile  rounded-lg customMaxWidth bgColor">
                                  <div className="number-statistic gs1-color-sky bgColor">
                                    {showloading && (
                                      <>
                                        <Loading />
                                      </>
                                    )}
                                    {!showloading &&
                                      `${consumptionBuscaEmpresa}`}
                                  </div>
                                  <div className="description-statistic bgColor">
                                    Consultas pelo nome da empresa
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="grid-container"></div>
                  </div>
                </div>
                <div></div>
              </div>
            )}
          </>
        </div>
        {idCompanySelect != "" && (
          <div>
            {perfil.indexOf("GS1") >= 0 && (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "40px",
                    marginBottom: "25px",
                  }}
                >
                  <h3
                    style={{
                      marginTop: 0,
                      paddingLeft: "15px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Histórico de consultas
                  </h3>

                  <div className="col-lg-4 col-sm-12 mb-4 mb-sm-2 float-md-right">
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label
                            style={{
                              display: "block",
                              marginBottom: "4px",
                              fontSize: "14px",
                              color: "#333",
                            }}
                          >
                            Data Inicial
                          </label>
                          <DatePicker
                            value={startHistoryConsult}
                            onChange={handleStartDateHistoryChange}
                            clearable
                            inputtable
                            inputFormat="DD/MM/YYYY"
                            locale="pt-BR"
                            size="sm"
                            tipo="month"
                          />
                        </div>

                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label
                            style={{
                              display: "block",
                              marginBottom: "4px",
                              fontSize: "14px",
                              color: "#333",
                            }}
                          >
                            Data Final
                          </label>
                          <div
                            style={{
                              display: "inline-block",
                              marginLeft: "5px",
                            }}
                          >
                            <DatePicker
                              value={endHistoryConsult}
                              onChange={handleEndDateHistoryChange}
                              clearable
                              inputtable
                              inputFormat="DD/MM/YYYY"
                              locale="pt-BR"
                              size="sm"
                              tipo="month"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <BarChart
                  startDate={startHistoryConsult as Date}
                  endDate={endHistoryConsult as Date}
                  token={jwt}
                  empresaID={
                    perfil.indexOf("GS1") >= 0 ? idCompanySelect : empresaId
                  }
                />
                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "15px",
                    marginLeft: "10px",
                  }}
                >
                  <span>
                    As informações disponíveis refletem as condições do contrato
                    atual.
                  </span>
                </div>
              </>
            )}
          </div>
        )}
      </TemplateBackend>
    </>
  );
};
export default NewDashboard;
